import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useMutationCreateResourceV2 } from './useMutationCreateResourceV2.js';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';
import { resourceDetailsQueryKeys } from '../../resource-detail/queries/resourceDetailsQueryKeys.js';
import { handleUpload } from '../../upload/utils/handleUpload.js';
import { UploadTaskPriority } from '@fabric-app/types/upload';

const useMutationCreateNotepadResource = () => {
  const mutationCreateResource = useMutationCreateResourceV2();
  const { data: user } = useQueryUserInfo();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({ file, onProgressUpdate, abortSignal, targetResourceId }) => {
      const { key, file: uploadedFile } = await handleUpload({
        data: {
          type: "file",
          file,
          available: true
        },
        userTier: user?.subscription?.tier,
        bucket: "notepad-embeds",
        abortSignal,
        onProgress: onProgressUpdate ? ({ overall, uploadSpeed }) => onProgressUpdate(overall, uploadSpeed) : void 0,
        priority: UploadTaskPriority.Instant
      });
      const thumbnailUrl = uploadedFile.type.startsWith("image/") ? URL.createObjectURL(uploadedFile) : void 0;
      const resource = await mutationCreateResource.mutateAsync({
        data: {
          createType: "file",
          body: {
            attachment: {
              path: key,
              filename: uploadedFile.name
            },
            mimeType: uploadedFile.type,
            name: null,
            parentId: targetResourceId,
            tags: [],
            comment: void 0
          },
          optimisticData: {
            file: uploadedFile,
            tags: [],
            parent: {
              id: targetResourceId,
              name: "Notepad"
            },
            thumbnailUrl
          }
        },
        disableToast: true,
        disableAddToCache: true,
        action: "notepad-embed"
      });
      return resource;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: resourceDetailsQueryKeys.assets(variables.targetResourceId)
      });
    }
  });
  return mutation;
};

export { useMutationCreateNotepadResource };
//# sourceMappingURL=useMutationCreateNotepadResource.js.map
